import FollowBookmark from './followBookmark'

const followBookmark = new FollowBookmark()

followBookmark.init()
